<script setup lang="ts">
import {
  effectiveAllergenDisplayList,
  effectiveAllergenText,
  showsMakerDisclaimer,
} from "~/utils/effectiveAllergens";

// The product modal's allergen declaration, one copy for the store, Group Select store, menu
// preview and order-edit modals. `modifiers` are the options the customer has PICKED, never the
// ones on offer: a bundle, or any pick, shows only the maker sentence (case A).
//
// The modal renders it in two places, so no solid line sits between two accordions: `summary`
// goes under the description (the maker sentence, or the Dietaries line), `allergens` goes in
// the accordion stack (the Allergens accordion, absent in case A).
const props = defineProps<{
  product: Record<string, unknown> | null;
  part: "summary" | "allergens";
  modifiers?: unknown[];
  makerName?: string | null;
}>();

const line = computed(() => ({ ...props.product, modifiers: props.modifiers ?? [] }));

const allergens = computed(() => {
  const list = effectiveAllergenDisplayList(line.value);
  return list.length ? list : [effectiveAllergenText(line.value)];
});
</script>

<template>
  <AllergenDeclaration
    v-if="part === 'summary'"
    class="product-modal-allergens grey-text"
    :line="line"
    :maker-name="makerName"
    :tooltip="true"
    :show-allergens="false"
  />
  <DynamicAccordion
    v-else-if="!showsMakerDisclaimer(line)"
    title="Allergens"
    subtitle="Although our Makers try their best to list all the ingredients they use in each of their meals, they are unable to guarantee an allergy-free cooking environment. Therefore, if you have a severe food allergy, we would recommend not ordering on the platform at this time."
    :list="allergens"
  />
</template>
